import React, { Component, Fragment } from 'react'
import {
  Dialog,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'

import SkuSelectionPage from './SkuSelectionPage'
import DetailSelectionPage from './DetailSelectionPage'
import RolesSelectionPage from './RolesSelectionPage'
import LoadingPage from './LoadingPage'

import { PAGE } from '../constants'
import styles from '../styles.scss'


class AddPopup extends Component {
  constructor(props) {
    super(props)
    this.initProductDetails = {
      segment: "",
      line: "",
      family: "",
      platform: "",
      sku: "",
      // common fields
      productSku: "",
      gpuSku: "",
      boardSku: "",
      fbWidth: "",
      devid: "",
      devid_b: "",
      architecture: "",
      productApplicationsEngineer: [],
      applicationsEngineeringDirector: [],
      softwareProgramManager: [],
      productManager: [],
    }
    this.state = {
      currPage: PAGE.SKU_SELECTION,
      productDetails: this.initProductDetails
    }
  }

  componentDidMount() {
    this.onReset()
  }

  componentDidUpdate(prevProps) {
    // if product creation is in progress, render loading page
    if (!prevProps.creatingProduct && this.props.creatingProduct) this.setState({ currPage: PAGE.SKU_LOADING })
    // if product creation was in progress but stopped, hide loading page
    if (prevProps.creatingProduct && !this.props.creatingProduct) this.setState({ currPage: PAGE.SKU_SELECTION })
  }

  componentWillUnmount() {
    // make sure popup is closed before unmounting component
    if(this.props.popupActive) this.onTogglePopup()
  }

  handleChange = (property, value, isDropdown) => {
    const oldProductDetails = Object.assign({}, this.state.productDetails)
    let productDetails = {...this.state.productDetails, [property]: isDropdown ? value.value : value}
    if (property === "productSku"){
      const { sku, family, platform } = value.attrs
      productDetails = {
        ...productDetails,
        sku,
        family,
        platform 
      }
    }
    this.setState({ productDetails }, () => {
      const { productDetails } = this.state
      const segmentLineChange = (oldProductDetails.segment != productDetails.segment) || (oldProductDetails.line != productDetails.line)
      if (productDetails.segment && productDetails.line && segmentLineChange) this.props.onSegmentLineChange(productDetails.segment, productDetails.line)
    })
  }

  headerRenderer = () => {
    return (
      <Fragment>
        <h2 className={styles.popupHeader}>Add New Product</h2>
        <hr/>
      </Fragment>
    )
  }

  bodyRenderer = () => {
    const { currPage } = this.state
    const {
      segmentSources,
      lineSources,
      productSkuSources,
      loadingSkuList,
      employeeList,
      fetchEmployeeList,
      isEmployeeListLoading,
    } = this.props

    switch(currPage) {
      case PAGE.SKU_SELECTION:
        return (
          <SkuSelectionPage 
            productDetails = {this.state.productDetails}
            handleChange = {this.handleChange}
            segmentSources = {segmentSources} 
            lineSources = {lineSources}
            productSkuSources = {productSkuSources}
            loadingSkuList = {loadingSkuList}
          />)
      case PAGE.SKU_DETAILS_SELECTION:
        return (
          <DetailSelectionPage 
            productDetails = {this.state.productDetails}
            handleChange = {this.handleChange}
          />)
      case PAGE.SKU_ROLES_SELECTION:
        return (
          <RolesSelectionPage 
            productDetails = {this.state.productDetails}
            handleChange = {this.handleChange}
            employeeList = {employeeList}
            fetchEmployeeList = {fetchEmployeeList}
            isLoading = {isEmployeeListLoading}
          />)
      case PAGE.SKU_LOADING:
        return (
          <LoadingPage 
            productDetails = {this.state.productDetails}
          />)
    }
  }

  onBack = () => {
    this.setState({ currPage: this.state.currPage - 1 })
  }

  onNext = () => {
    this.setState({ currPage: this.state.currPage + 1 })
  }

  onSave = () => {
    this.setState({ currPage: PAGE.SKU_LOADING })
    this.props.onSave(this.state.productDetails)
  }

  onCancel = () => {
    this.onReset()
    this.props.onTogglePopup()
  }

  onReset = () => {
    this.setState({ 
      currPage: PAGE.SKU_SELECTION,
      productDetails: this.initProductDetails
    })
  }

  onTogglePopup = () => {
    if (this.state.currPage !== PAGE.SKU_LOADING) this.props.onTogglePopup()
  }

  getActions = () => {
    const {
      productDetails,
      currPage,
    } = this.state
    
    let skuSelectionActions = [
      { label: 'Back', onClick: this.onBack, disabled: true },
      { label: 'Next', onClick: this.onNext, disabled: productDetails.segment === "" || productDetails.line === "" || productDetails.productSku === ""  },
      { label: 'Cancel', onClick: this.onCancel },
    ]
    let skuDetailsActions = [
      { label: 'Back', onClick: this.onBack },
      { label: 'Next', onClick: this.onNext, disabled: productDetails.gpuSku === "" || productDetails.architecture === '' || productDetails.fbWidth === "" || productDetails.devid === '' },
      { label: 'Cancel', onClick: this.onCancel },
    ]
    let rolesSelectionActions = [
      { label: 'Back', onClick: this.onBack },
      { label: 'Save', onClick: this.onSave },
      { label: 'Cancel', onClick: this.onCancel },
    ]
    let skuLoadingActions = [
      { label: 'Back', disabled: true },
      { label: 'Save', disabled: true },
      { label: 'Cancel', disabled: true },
    ]

    switch(currPage) {
      case PAGE.SKU_SELECTION:
        return skuSelectionActions
      case PAGE.SKU_DETAILS_SELECTION:
        return skuDetailsActions
      case PAGE.SKU_ROLES_SELECTION:
        return rolesSelectionActions
      case PAGE.SKU_LOADING:
        return skuLoadingActions
    }
  }

  render() {
    const {
      popupActive,
    } = this.props

    return (
      <React.Fragment>
        <Dialog
          actions={this.getActions()}
          theme={styles}
          active={popupActive}
          onOverlayClick = {this.onTogglePopup}
          onEscKeyDown={this.onTogglePopup}
          styleName='popupContainer'
        >
          {this.headerRenderer()}
          {this.bodyRenderer()}
        </Dialog>
      </React.Fragment>
    )
  }
}

export default CSSModules(AddPopup, styles)
